import "@dreamcam/web-player";
import "@dreamcam/all-in-one-player-babylonjs";
import { AllInOnePlayer, Version } from "@dreamcam/all-in-one-player-common";
import { FMP4ProtocolVersion, Log } from "@dreamcam/web-player";
import { Engine } from "@babylonjs/core";

const player = <AllInOnePlayer>document.getElementById("player");
const playButton = <HTMLButtonElement>document.getElementById("play");
const stopButton = <HTMLButtonElement>document.getElementById("stop");
const inspectButton = <HTMLButtonElement>document.getElementById("inspect");
const setAttr = <HTMLButtonElement>document.getElementById("set");
const removeAttr = <HTMLButtonElement>document.getElementById("remove");
const attr = <HTMLInputElement>document.getElementById("attr");
const value = <HTMLInputElement>document.getElementById("value");
const logLevelSelect = <HTMLSelectElement>document.getElementById("log_level");
const version = <HTMLSpanElement>document.getElementById("version");

let isInspectorInitialized = false;

async function initInspector() {
    if (isInspectorInitialized)
        return;
    isInspectorInitialized = true;
    await import("@babylonjs/core/Debug/debugLayer");
    await import("@babylonjs/inspector");
}

async function inspect() {
    await initInspector()
    if ((player.engine as Engine).scenes[0].debugLayer.isVisible())
        (player.engine as Engine).scenes[0].debugLayer.hide();
    else
        await (player.engine as Engine).scenes[0].debugLayer.show({ embedMode: true, overlay: true, handleResize: true, enablePopup: true, showInspector: true, globalRoot: document.body });
}


function save() {
    const data: Record<string,string> = {};
    for (let i = 0; i < player.attributes.length; i++)
    {
        const a = player.attributes.item(i);
        if(a && a.name !== "id")
            data[a.name] = a.value;
    }
    localStorage.setItem("playerdata", JSON.stringify(data));
}

function load() {

    const json = localStorage.getItem("playerdata");
    if(json)
    {
        const data = JSON.parse(json)
        for(const k in data)
        {
            player.setAttribute(k,data[k]);
        }
    }
}

function readParams() {
    const params = new URLSearchParams(document.location.search)
    if(params.has("url"))
        player.src = decodeURI(params.get("url")!);
    if (params.has("pt"))
        player.passthroughToken = params.get("pt")!;
    if(params.has("mask"))
        player.includeMask = params.has("mask");
    if(params.has("fmp4"))
        player.fmp4ProtocolVersion = FMP4ProtocolVersion[params.get("fmp4")! as "V1" | "V3" | "V4"];
}

async function play() {
    await player.play()
}

async function stop() {
    await player.stop();
}

playButton.addEventListener("click", play);
stopButton.addEventListener("click", stop);

inspectButton.addEventListener("click", inspect);

setAttr.addEventListener("click", () => {
    player.setAttribute(attr.value, value.value);
});

removeAttr.addEventListener("click", () => {
    player.removeAttribute(attr.value);
});

logLevelSelect.addEventListener("change", () => {
    Log.level = logLevelSelect.selectedIndex;
});

window.addEventListener("unload", save);
load();
readParams()
version.innerHTML = Version; 

const m = (module as any);
if (m.hot) {
    m.hot.accept(() => {
        location.reload();
    });
}